import { Checkbox, Col, Input, Row } from 'antd';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import {
  CompaniesInfiniteSelectField,
  DocumentTypesInfiniteSelectField,
  InputDate,
  InputDecimal,
} from '@/components/_common';
import moment from 'moment';
import { AccountReceivableListRequest } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import { DateTimeFormat } from '@/utils/moment';

export default function AccountReceivableListExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<AccountReceivableListRequest>) {
  function handleParams(params: typeof queryParams) {
    setQueryParams((state) => ({ ...state, ...params }));
  }

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} lg={4} md={12}>
        <Input
          value={queryParams?.code}
          onChange={({ target: { value } }) => handleParams({ code: value })}
          placeholder="Código"
        />
      </Col>

      <Col span={24} lg={10} md={12}>
        <CompaniesInfiniteSelectField
          placeholder="Empresa"
          allowClear
          style={{ width: '100%' }}
          onChange={(values) => handleParams({ companyId: values })}
        />
      </Col>

      <Col span={24} lg={10} md={12}>
        <Input
          value={queryParams?.debtor}
          onChange={({ target: { value } }) => handleParams({ debtor: value })}
          placeholder="Devedor"
        />
      </Col>

      <Col span={24} lg={10} md={12}>
        <Input
          value={queryParams?.description}
          onChange={({ target: { value } }) =>
            handleParams({ description: value })
          }
          placeholder="Descrição"
        />
      </Col>

      <Col span={24} lg={6} md={12}>
        <Input
          value={queryParams?.documentNumber}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, documentNumber: value }))
          }
          placeholder="Nº documento"
        />
      </Col>

      <Col span={24} lg={8} md={12}>
        <DocumentTypesInfiniteSelectField
          placeholder="Tipo Doc."
          allowClear
          style={{ width: '100%' }}
          onChange={(values) => handleParams({ documentTypeId: values })}
        />
      </Col>

      <Col span={24} lg={6} md={12}>
        <InputDate
          placeholder="Emissão"
          value={
            queryParams?.emissionDate
              ? moment(queryParams?.emissionDate)
              : undefined
          }
          onChange={(value) =>
            handleParams({ emissionDate: value?.format(DateTimeFormat) })
          }
        />
      </Col>

      <Col span={24} lg={6} md={12}>
        <InputDate
          placeholder="Vencimento"
          value={
            queryParams?.dueDate ? moment(queryParams?.dueDate) : undefined
          }
          onChange={(value) =>
            handleParams({ dueDate: value?.format(DateTimeFormat) })
          }
        />
      </Col>

      <Col span={24} lg={6} md={12}>
        <InputDate
          placeholder="Pagamento"
          value={
            queryParams?.payDate ? moment(queryParams?.payDate) : undefined
          }
          onChange={(value) =>
            handleParams({ payDate: value?.format(DateTimeFormat) })
          }
        />
      </Col>

      <Col span={24} lg={6} md={12}>
        <InputDecimal
          value={queryParams?.installmentValue}
          onChange={(value) => handleParams({ installmentValue: value })}
          placeholder="Valor"
        />
      </Col>

      <Col span={24} lg={6} md={12}>
        <Checkbox
          onChange={(e) => {
            setQueryParams((prev) => ({
              ...prev,
              rows: e.target.checked ? 500 : 10,
            }));
          }}
          style={{ fontWeight: 'bold' }}
        >
          Listar todos
        </Checkbox>
      </Col>
    </Row>
  );
}
